<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        hide-header
        hide-footer
        @hidden="close">
        <div class="modal-body">
            <p class="exportText">記録をエクスポートしますか？</p>
            <div class="btnWrapper d-flex flex-column">
                <b-button
                    type="button"
                    class="btn btn-yokumiru-user mt-2 mb-2"
                    @click="exportMedicalRecord('ja', $event)">
                    エクスポート
                </b-button>
                <b-button
                    type="button"
                    class="btn btn-yokumiru-user mt-2 mb-2"
                    @click="exportMedicalRecord('en', $event)">
                    英語に翻訳してエクスポート
                </b-button>
                <b-button
                    type="button"
                    class="btn btn-yokumiru-gray mt-2 mb-4"
                    @click="close">
                    キャンセル
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../constants'

export default {
    name: 'UserExportMedicalRecordModal',

    data: function () {
        return {
            modalShow: false,
            medicalRecord: null,
        }
    },

    created: function () {
        bus.$on('open-modal-user-export-medical-record', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-user-export-medical-record')
    },

    methods: {
        /**
         * モーダル表示
         * @param {object} medicalRecord
         */
        open: function (medicalRecord) {
            this.medicalRecord = medicalRecord
            this.modalShow = true
        },

        /**
         * モーダル非表示
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * 相談記録PDFエクスポート
         * @param {string} locale
         */
        exportMedicalRecord: function (locale = 'ja') {
            if (!this.medicalRecord) return

            bus.$emit('user-medical-record-exporting')
            axios.get(`${constants.user.medical_records.endpoint.base}/${this.medicalRecord.id}/export?locale=${locale}`)
            this.close()
        },
    },
}
</script>

<style scoped lang="scss">
.exportText {
    margin: 15px 0;
    color: #2A2E31;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
}

.btnWrapper {
    width: 240px;
    margin: 0 auto;

    .btn {
        padding-top: 10px;
        padding-bottom: 10px;
        border: none;
    }
}
</style>
